import { useAppSettings } from "Shared/Hooks";
import { useRootStore } from "Store/RootStore";

export const useAuthScopes = () => {
    const { clientIdInMicrosoft, clientIdInTorus } = useAppSettings();
    const authStore = useRootStore("AuthStore");

    const clientId = authStore.LoginType === "Gallatin" ? clientIdInMicrosoft : clientIdInTorus;
    return [`${clientId}/.default`];
};
